import React from 'react'
import { Flex } from '@rebass/grid'

const Row = (props) => <Flex {...props} />

Row.defaultProps = {
   mx: ['-16px', '-12px'],
   flexWrap: 'wrap',
}

export default Row
